import React, { useState, useEffect, useRef } from 'react';
import { useStore } from 'react-context-hook'
import MessagesThread from './MessagesThread'
import { TouchableOpacity, ImageBackground, Image, View, ScrollView, ViewPagerAndroid, TextComponent } from "react-native";
import { Container, H1,  Header,  Title,  Button,  Card,  CardItem,  Icon,  Text,  Left,  Right,  Body, List, ListItem, Thumbnail, Content } from "native-base";
import { Layouts } from '../../utils';
import * as Logger from '../../utils/Logger/index'
import Styles from '../../Styles'
import { GiftedChat } from 'react-native-gifted-chat'
import Swiper from 'react-native-deck-swiper'
import * as DashboardData from '../../utils/TestData/DashboardData'
import * as ProfileData from '../../utils/TestData/ProfileData'
import * as MessagesData from '../../utils/TestData/MessagesData'



//Note: main screen for messages - in web displays list and chat side by side
//on mobile, displays list and then selected chat
export default function MessagesMainScreen({ navigation }) {

    Layouts.StackNavigationHeader({navigation});

    const [platform] = useStore('platform')
    const [displayDesktop] = useStore('displayDesktop')
    const [enableConsoleLogging] = useStore('enableConsoleLogging')
    const [enableSentryLogging] = useStore('enableSentryLogging')
    const [enableAlertLogging] = useStore('enableAlertLogging')

    const [threads, setThreads] = useState(DashboardData.matchData)
    const [profile, setProfile] = useState(ProfileData.profileData1)
    
    //testing data
    // const [threadData1, setThreadData1] = useState(MessagesData.theadData1)
    // const [threadData2, setThreadData2] = useState(MessagesData.theadData2)

    const [profilePics, setProfilePics] = useState(DashboardData.matchData)
    const [picCount, setPicCount] = useState(profilePics.length)

    const [activeThread, setActiveThread] = useState(0)
    const [messages, setMessages] = useState([])

    //load chat thread on first load
    useEffect(function getMessages() {
        fetch(MessagesData.threadData1)
            .then(setMessages(MessagesData.threadData1))
        // Logger.WriteLogs(false, 'initial load', enableConsoleLogging,enableSentryLogging,enableAlertLogging)
    }, [])

    //load chat thread on click
    const onThreadClick = (e, thread) => {
        try {
            setMessages(MessagesData.threadData2)
            setProfile(ProfileData.profileData2)
            // Logger.WriteLogs(false, 'clicked thread', enableConsoleLogging, enableSentryLogging, enableAlertLogging)
            // Logger.WriteLogs(false, messages[0].text, enableConsoleLogging, false, enableAlertLogging)
        } catch (error) {
            Logger.WriteLogs(true, error, enableConsoleLogging, enableSentryLogging, enableAlertLogging)
        }
    }

    function handleSend(newMessage = []) {
        setMessages(GiftedChat.append(messages, newMessage))
    }

    const useSwiper = useRef(null).current
    const handleOnSwipedLeft = () => useSwiper.swipeLeft()
    const handleOnSwipedTop = () => useSwiper.swipeTop()
    const handleOnSwipedRight = () => useSwiper.swipeRight()
  
  return (
    
    <ImageBackground source={global.BackgroundImage} style={displayDesktop ? Styles.Typography.messagesContainer.desktop : Styles.Typography.messagesContainer.mobile}>
      <View style={displayDesktop ? Styles.Typography.messagesListContainer.desktop : Styles.Typography.messagesListContainer.mobile}>
        <ScrollView style={{flex:1, borderRightWidth: 1, borderColor: Styles.Colors.colorPalette.Dark}} contentContainerStyle={{flexGrow:1}}>
            <List>
            {threads.map(thread =>
                <ListItem onPress={e => onThreadClick(thread)}>
                <Left style={{flex:1}}>
                    <Thumbnail source={thread.image} />
                </Left>
                <Body style={Styles.Typography.MessagesListBody.all}>
                    <Text style={Styles.Typography.MessagesListText.all}>{thread.fullName}</Text>
                    <Text style={Styles.Typography.MessagesListText.all} note>{thread.lastMsg}</Text>
                </Body>
                <Right style={{flex:1}}>
                    <Text style={Styles.Typography.MessagesListText.all} note>Time</Text>
                </Right>
                </ListItem>   
            )}
            </List>

        </ScrollView>

        <View style={{flex:1}}>
            <H1>
                {activeThread.fullName}
            </H1>
            
            {/* <MessagesThread 
                threadData={messages}               
            /> */}

            <GiftedChat 
                messages={messages}
                onSend={newMessage => handleSend(newMessage)}
                user={{_id:1}}
            />

        </View>

      </View>

    {displayDesktop === true ? (
      <View style={Styles.Typography.FullProfileGeneral.messagesContainer}>
        <ScrollView style={{flex:1}} contentContainerStyle={{ flexGrow:0.5, flexDirection:'column', alignItems:'center', padding:0 }}>

              <Styles.Components.FullProfileContainer 
                name={profile.name.firstName}
                catchphrase={profile.basicInfo.catchphrase}
                profilePic={DashboardData.profilePic1}
                profileData={profile}
              />
              
              <Styles.Components.ProfilePicViewer 
                profilePics={profilePics}
                picCount={picCount}
              />              

          </ScrollView>
        </View>   
      ) : (
        <View></View>
      )}     

    </ImageBackground>
  );
}